import React, { useContext } from "react";
import styles from "./Comment.module.scss";
import PathContext from "../../context/path";
const Comment = (props) => {
  const { name, position, text, img, color } = props;
  const path = useContext(PathContext);
  let wrapClass = `${styles.wrap}`;
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${color}`]}`;
  }
  return (
    <>
      <div className={wrapClass} data-animate={'fade-in-up'}>

        <div className={styles.header}>
        
        <div className={styles.img}>
          <div className={styles.img__svg}>
            <svg width="140" height="141" viewBox="0 0 140 141" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M131.793 52.9433L87.1023 8.25266C77.5739 -1.27572 62.1253 -1.27572 52.5969 8.25266L7.90631 52.9433C-1.62207 62.4717 -1.62208 77.9202 7.9063 87.4486L52.5969 132.139C62.1253 141.668 77.5739 141.668 87.1023 132.139L131.793 87.4486C141.321 77.9202 141.321 62.4717 131.793 52.9433Z" stroke="#003333" strokeWidth="1.5" strokeMiterlimit="10" />
            </svg>
          </div>
      
          <img src={`${path}/img/${img}.webp`} srcSet={`${path}/img/${img}@2x.webp 2x`} alt="" />
        </div>
        
        <div className={styles.name}><span>{name},</span> {position}</div>
        </div>
        <div className={styles.text}>
          <div className={styles.text__icon}>
            <svg width="35" height="30" viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.255 29.1949C10.147 29.1949 12.649 26.2759 12.649 22.3839V7.09388C12.649 3.34088 10.147 0.143881 6.255 0.00488281C2.641 0.00488281 0 3.20188 0 6.95488V22.2449C0 26.1369 2.502 29.1949 6.255 29.1949ZM27.8 29.1949C31.692 29.1949 34.194 26.2759 34.194 22.3839V7.09388C34.194 3.34088 31.692 0.143881 27.8 0.00488281C24.186 0.00488281 21.545 3.20188 21.545 6.95488V22.2449C21.545 26.1369 24.047 29.1949 27.8 29.1949Z" fill="#7ED3F7" />
            </svg>
          </div>
          {text}
        </div>
        <div className={styles.bg}></div>
      </div>
    </>
  );

}

export default Comment;
